import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthWebService } from "app/services/authweb.service";
import { CountryService } from "app/services/country.service";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { DepotListFilterConfig } from "app/shared/filter/filter.constant";
import { ToastNotificationComponent } from 'app/shared/toast-notification/toast-notification.component';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { ToastrService } from "ngx-toastr";
import { CarrierDepotService } from "../service/carrier-depot.service";
import { OcasService } from 'app/ocas/Service/ocas.service';

@Component({
  selector: "app-carrier-depot-list",
  templateUrl: "./carrier-depot-list.component.html",
  styleUrls: ["./carrier-depot-list.component.scss"],
})
export class CarrierDepotListComponent implements OnInit {
  isLoading: boolean = false;
  carrierId: number;
  depotId:number;
  depot:any;
  ddlCountries = [];
  carrierDepotList: any = [];
  currentPage = 1;
  page = 1;
  pageSize: number = 10;
  count: number = 0;
  user: any = {};
  isEmpty: boolean = false;
  filterConfig = DepotListFilterConfig;
  @ViewChild("content") modal: NgbModal;
  @ViewChild('add') addModal: NgbModal;
  @ViewChild('edit') editModal: NgbModal;
  @ViewChild('detail') detailModal: NgbModal;
  @Output() prevNext = new EventEmitter();
  deleteConfirm = "";
  closeResult: string = "";
  removeRef: any;
  @Input() isInStepper: boolean = false;

  constructor(
    private authWebService: AuthWebService,
    private _service: CarrierDepotService,
    public utility: UtilityServiceService,
    private _router: Router,
    private modalService: NgbModal,
    private _activatedRoute: ActivatedRoute,
    private toastService: ToastNotificationService,
    private confirmDialogService: ConfirmDialogService,
    private _ocas:OcasService
    
  ) {
    this.user = this.authWebService.userData
      ? this.authWebService.userData.User
      : null;
    this._activatedRoute.params.subscribe((params: Params) => {
      this.carrierId = params["id"];
    });
    if(this._router.url.includes('carrier/account/add')){
      this.carrierId = this.utility.ctrlPages[this.utility.acc.First].carrierId
    }
  }
  @Output() nextStepEmitter = new EventEmitter<number>();
  @Output() prevStepEmitter = new EventEmitter<number>();
  ngOnInit(): void {
    this.getDepotList();
    this.utility.page = 1;
  }

  getDepotList = (page: number = 1, pageSize: number = 10) => {
    this.isLoading = true;
    this._service.getDepotList(this.carrierId).subscribe((response: any) => {
      this.carrierDepotList = response;
      if (response && response.length > 0) {
        this.count = response.length;
        this.isLoading = false;
      } else {
        this.isEmpty = true;
        this.isLoading = false;
      }
    },error =>{
      this.isEmpty = true;
      this.isLoading = false;
    });
  };

  addDepotModal() {
    this.modalService.open(this.addModal, { ariaLabelledBy: 'modal-basic-title',size: 'xl', scrollable: true  }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.getDepotList();
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.getDepotList();
      },
    );
  }

  editDepotModal(depot) {
    if(depot) this.depotId = depot.id;
    this.modalService.open(this.editModal, { ariaLabelledBy: 'modal-basic-title',size: 'xl', scrollable: true  }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.getDepotList();
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  onViewDetails(depot: any) {
    if(depot) this.depot = depot;
    this.modalService.open(this.detailModal, { ariaLabelledBy: 'modal-basic-title',size: 'xl', scrollable: true  }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  onNextOrPrevious(page: number = 1) {
    this.getDepotList(page, this.pageSize);
    this.currentPage = page;
    return page;
  }

  onDeleteDepot(depot) {
    this.confirmDialogService.confirmThis(
      "Are you sure you want to delete this depot information?",
      () => {
        this.isLoading = true;

        this._service.delete(depot.id).subscribe(
          (data) => {
            this.toastService.success(
              "The depot information was deleted successfully",
              "success"
            );
            this.getDepotList();

            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
            this.toastService.error(
              "Your request could not be processed succesfully.Please contact the system admin if the problem persists.",
              "Delete driver(s) that are linked to this depot!"
            );
          }
        );
      },
      () => {
        return false;
      }
    );
  }

  onDelete(id) {
    this._service.deleteDepot(id).subscribe(
      (result) => {
        this.toastService.success(
          `Vehicle Type ${this.removeRef.code} deleted.`,
          "Delete Vehicle Type"
        );
        if (result != null) {
          this.onNo();
          this.getDepotList();
        }
      },
      (error) => {
        error = error.json();
        this.toastService.error(
          `Vehicle Type ${this.removeRef.code} was not deleted.`,
          "Delete Vehicle Type"
        );
      }
    );
  }

  onNo() {
    console.log("no");
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  applyFilters(value) {
    console.log(value);

  }

  next() {
    this.utility.carrierDepotList = this.carrierDepotList.length;
    if(this.carrierDepotList.length === 0){
      return

    }
    
    this.prevNext.emit('next');
  }
  
  back() {
    this.prevNext.emit('back');
  }

  nextStep(){
    this.nextStepEmitter.emit(0)
  }

  prevStep(){
    this.prevStepEmitter.emit(0)
  }
}
